import * as ebikesServices from './ebikesServices';

export { ebikesServices };
